import { required, validate, min } from 'labguard-cdk'

const min0 = min(0)
const min1 = min(1)

/**
 * Validates a system settings form object
 * @param {Object} settings the settings.
 * @return {Object} An object with the field names which are in error as keys and the corresponding error messages
 * as values. The object will be empty if there was no error.
 */
export const validateSettings = ({ cfr21, smtp } = {}, { cfr21Enabled, ldapEnabled }) => ({
  cfr21: validateCFR21(cfr21, { cfr21Enabled, ldapEnabled }),
  smtp: validate([validateSMTP])(smtp),
})

const validateSMTP = ({ hasSmtpConfiguration, outgoingServer, authenticationRequired, port, username, password }) => ({
  username: hasSmtpConfiguration && authenticationRequired && required(username),
  password: hasSmtpConfiguration && authenticationRequired && required(password),
  port: validate([...(hasSmtpConfiguration ? [required] : []), min0])(port),
  outgoingServer: hasSmtpConfiguration && required(outgoingServer),
})

const validateCFR21 = (
  { expiredSessionInactivityPeriod, notLdap, ldap, useLdap } = {},
  { cfr21Enabled, ldapEnabled }
) => ({
  expiredSessionInactivityPeriod:
    (cfr21Enabled || ldapEnabled) && validate([required, min0])(expiredSessionInactivityPeriod),
  notLdap: cfr21Enabled && !useLdap && validate([validateNotLdap])(notLdap),
  ldap: ldapEnabled && useLdap && validate([validateLdap])(ldap),
})

const validateNotLdap = ({
  connectionFailureNumberBeforeWarning,
  connectionFailureNumberMonitoringPeriod,
  connectionFailureNumberBeforeBlocking,
  lockWarningMessage,
  globalAlertMessage,
  minimumLoginLength,
  minimumPasswordLength,
  passwordValidityPeriod,
  hasPasswordValidityPeriod,
  hasConnectionFailureWarning,
  hasConnectionFailureBlocking,
  checkPasswordHistory,
  passwordHistoryCheckingCount,
} = {}) => ({
  connectionFailureNumberMonitoringPeriod: validate([required, min0])(connectionFailureNumberMonitoringPeriod),
  connectionFailureNumberBeforeWarning:
    hasConnectionFailureWarning && validate([required, min1])(connectionFailureNumberBeforeWarning),
  connectionFailureNumberBeforeBlocking:
    hasConnectionFailureBlocking && validate([required, min1])(connectionFailureNumberBeforeBlocking),
  lockWarningMessage: hasConnectionFailureBlocking && required(lockWarningMessage),
  globalAlertMessage: hasConnectionFailureWarning && required(globalAlertMessage),
  minimumLoginLength: validate([required, min0])(minimumLoginLength),
  minimumPasswordLength: validate([required, min0])(minimumPasswordLength),
  passwordValidityPeriod: hasPasswordValidityPeriod && validate([required, min1])(passwordValidityPeriod),
  passwordHistoryCheckingCount: checkPasswordHistory && validate([required, min1])(passwordHistoryCheckingCount),
})

const validateLdap = ({ server } = {}) => ({
  server: required(server),
})
